import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

const ROLES = [
  { v: "spa_therapist", l: "Spa Therapist" },
  { v: "receptionist", l: "Receptionist" },
  { v: "housekeeping", l: "Housekeeping" },
];

export default function Careers() {
  const [f, setF] = useState({ name: "", phone: "", email: "", city: "", experience: "", role: "", resume_url: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/leads/career", f);
      toast.success("Application received. HR will contact you soon.");
      setF({ name: "", phone: "", email: "", city: "", experience: "", role: "", resume_url: "", message: "" });
      setTimeout(() => window.open("https://wa.me/919000100001?text=I%20applied%20for%20a%20role%20at%20HAMMAM", "_blank"), 800);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="careers-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 lg:grid-cols-2 gap-16">
      <div>
        <div className="label-eyebrow mb-4">Careers</div>
        <h1 className="text-5xl lg:text-6xl font-heading text-white mb-8">Join a<br/>craft-first team.</h1>
        <p className="text-hsecondary leading-relaxed">
          We're always looking for skilled therapists, warm receptionists and detail-obsessed housekeepers. If you take pride in your craft and value working in a men-only luxury environment, we'd love to hear from you.
        </p>
        <div className="mt-8 space-y-4">
          <div className="label-eyebrow">Currently hiring</div>
          {ROLES.map((r) => (
            <div key={r.v} className="border border-white/10 p-5 hover:border-hgold/40 transition-colors">
              <div className="font-heading text-xl text-white">{r.l}</div>
              <div className="text-hmuted text-sm mt-1">All 3 branches · Full-time</div>
            </div>
          ))}
        </div>
      </div>
      <form onSubmit={submit} className="border border-white/10 p-8 space-y-4" data-testid="careers-form">
        <input required placeholder="Full Name" data-testid="career-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none" />
        <div className="grid grid-cols-2 gap-4">
          <input required placeholder="Phone" data-testid="career-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none" />
          <input required type="email" placeholder="Email" data-testid="career-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <input required placeholder="City" data-testid="career-city" value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none" />
          <input required placeholder="Experience (years)" data-testid="career-experience" value={f.experience} onChange={(e) => setF({ ...f, experience: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none" />
        </div>
        <select required data-testid="career-role" value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none">
          <option value="">Applying for</option>
          {ROLES.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
        </select>
        <input placeholder="Resume URL (Google Drive, etc.)" data-testid="career-resume" value={f.resume_url} onChange={(e) => setF({ ...f, resume_url: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none" />
        <textarea rows="3" placeholder="Cover message" data-testid="career-message" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className="w-full bg-black border border-white/10 focus:border-hgold px-4 py-3 text-white outline-none resize-none" />
        <button type="submit" disabled={busy} data-testid="career-submit" className="gold-btn w-full justify-center">{busy ? "Submitting..." : "Apply now"}</button>
      </form>
    </div>
  );
}
